import React from "react";
import { Col, Row, Tag, Button, Popconfirm, Tooltip } from "antd";
import moment from "moment";
import { connect } from "react-redux";
import capitalize from "lodash/capitalize";
import { STATUS } from "config";
import * as Styled from "./styled";

const FBQOrderItem = ({
  order,
  onStatusUpdate,
  onCancelOrder,
  labData,
  showStatus,
}) => {
  const shipping = labData.shipping.find(
    (s) => s.pos_code === order.shipping.pos_code
  ) || { shippingmethod: "International shipping" };

  return (
    <Styled.Container>
      <Row>
        <Col span={12}>
          <h4>
            <a
              title="View on Etsy"
              target="_blank"
              href={`https://www.etsy.com/your/orders/sold?&order_id=${order.orderReference ||
                order.orderId}`}
            >
              #{order.orderReference || order.orderId}
            </a>{" "}
            - {order.shippingAddress ? order.shippingAddress.name : ""}
          </h4>
          {order.lineItems.map((i) => {
            return (
              <div key={i.transactionId} className="tnx">
                {/*<Avatar*/}
                {/*size={85}*/}
                {/*src={i.MainImage.url_75x75}*/}
                {/*shape="square"*/}
                {/*/>*/}
                <div className="details">
                  <p>
                    <strong>{i.product.name}</strong>
                  </p>
                  <div>
                    <div>
                      <strong>Option:</strong>{" "}
                      <span>
                        {i.product.cat_name} - {i.product.size}
                      </span>
                    </div>
                    <div>
                      <strong>Quantity:</strong> <span>{i.quantity}</span>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </Col>
        <Col span={6}>
          {order.status === "shipped" ? (
            <p>
              <strong>
                <Tooltip
                  title={moment(order.shippingDate).format(
                    "MMM DD, YYYY h:mmA"
                  )}
                >
                  Shipped {moment(order.shippingDate).fromNow()}
                </Tooltip>
              </strong>
            </p>
          ) : (
            <p>
              <strong>
                <Tooltip
                  title={moment(order.createdAt).format("MMM DD, YYYY h:mmA")}
                >
                  Ordered {moment(order.createdAt).fromNow()}
                </Tooltip>
              </strong>
            </p>
          )}
          <div>Order ID: E-{order.orderId}</div>
          <div>{shipping.shippingmethod}</div>
          {order.shippingAddress ? (
            <p>
              {order.shippingAddress.city}, {order.shippingAddress.state}{" "}
              {order.shippingAddress.country}
            </p>
          ) : null}
          {order.status === "shipped" && (
            <div>
              <div>
                <strong>Shipped by:</strong>{" "}
                <span className="text-upper">{order.carrierName}</span>
              </div>
              <div>
                <strong>Tracking #:</strong>{" "}
                <a
                  target="_blank"
                  href={`https://www.packagetrackr.com/track/${
                    order.trackingNumber
                  }`}
                >
                  {order.trackingNumber}
                </a>
              </div>
            </div>
          )}
          {/*{order.message_from_buyer && (*/}
          {/*<Alert*/}
          {/*showIcon*/}
          {/*icon={<Icon type="user" />}*/}
          {/*message={unescape(order.message_from_buyer)}*/}
          {/*type="warning"*/}
          {/*/>*/}
          {/*)}*/}
        </Col>
        <Col span={6} className="text-right">
          {showStatus && <Tag color="green">{STATUS[order.status]}</Tag>}
          <div>
            {["pending", "uploaded"].includes(order.status) && (
              <Popconfirm
                title="Confirm cancel order? Please call us if you do this, the order has already been submitted to the lab."
                onConfirm={() => onCancelOrder(order)}
              >
                <Button
                  type="primary"
                  title="Cancel Fulfillment - this will not actually cancel the order, please call us if you click this!"
                  icon="delete"
                  ghost
                />
              </Popconfirm>
            )}
          </div>
        </Col>
      </Row>
    </Styled.Container>
  );
};

export default connect((state) => state.lab)(FBQOrderItem);
